import React from "react"
import { Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { useTranslation } from "react-i18next"
import { APP_TYPES } from "utils/pageContentPermissions"

const AppTypeTabs = ({ activeAppType, availableAppTypes, onChange }) => {
  const { t } = useTranslation()

  if (!availableAppTypes || availableAppTypes.length <= 1) {
    return null
  }

  const tabs = [
    {
      id: APP_TYPES.CUSTOMER,
      label: t("Customer App"),
    },
    {
      id: APP_TYPES.RIDER,
      label: t("Rider App"),
    },
  ].filter(tab => availableAppTypes.includes(tab.id))

  return (
    <Nav tabs className="mb-3">
      {tabs.map(tab => (
        <NavItem key={tab.id}>
          <NavLink
            className={classnames({ active: activeAppType === tab.id })}
            onClick={() => onChange(tab.id)}
            style={{ cursor: "pointer" }}
          >
            {tab.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  )
}

export default AppTypeTabs
